import { searchBoxStyles } from "@insite/content-library/Widgets/Addresses/AddressBookSearchBox";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

searchBoxStyles.searchText = {
    iconProps: {
        src: Search,
        css: css`
            background-color: ${COLORS.white};
        `,
    },
    cssOverrides: {
        formField: css`
            > div[class^="FormInputWrapper"] {
                input {
                    padding-right: 40px !important;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        `,
    },
}